export const toggleReviewsModal = bool => {
	return {
		type: 'toggle-reviews-modal',
		payload: bool
	};
};
